import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './styles.scss'

export default class CollapsiblePanel extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.node, PropTypes.string,
    ]),
  }

  static defaultProps = {
    className: '',
    title: '',
    children: null,
  }

  render() {
    const { className, title, children } = this.props
    return (
      <div className={classNames(styles.panel, className)}>
        <input id="collapsible" className={styles.panel__checkbox} type="checkbox" />
        <label // eslint-disable-line jsx-a11y/label-has-for
          htmlFor="collapsible"
          className={styles.panel__label}
        >
          {title}
        </label>
        <div className={styles.panel__content}>
          {children}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./components/CollapsiblePanel/index.jsx